import $http from '@/libs/axios'
import { OneSignalAppId, OneSignalSafariId } from '@/constants/config'
import { getEnvironment } from '@/utils/env-helper'

class OneSignalService {
  static initOneSignal() {
    if (getEnvironment() === 'Development') {
      return
    }

    try {
      // @ts-ignore
      const OneSignal = window.OneSignal || []
      OneSignal.push(() => {
        OneSignal.init({
          appId: OneSignalAppId,
          safari_web_id: OneSignalSafariId,
          autoRegister: true,
          notifyButton: {
            enable: false,
          },
          allowLocalhostAsSecureOrigin: true,
        })
        OneSignal.getUserId()
          .then((userId: any) => {
            $http.defaults.headers.common.player_id = userId
          })
          .catch((error: any) => {
            console.error('Error while get user id in OneSignal', error)
          })
      })
    } catch (error) {
      console.error('Error while initialize OneSignal', error)
    }
  }
}

export default OneSignalService
